import { render, staticRenderFns } from "./MtdDetail.vue?vue&type=template&id=2b6249d0&"
import script from "./MtdDetail.vue?vue&type=script&lang=js&"
export * from "./MtdDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports